module.exports = __webpack_public_path__ + "img/banner.019aeb81.png";